
import React from "react";

interface Props {
    started: string
    deadline: string
    extraTimeAllowance?: number
    finished?: string
    onAutoSubmit?: () => void
}

interface State {
    interval: any
    autoSubmitted: boolean
}

export default class StudentTimer extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props)
        this.state = {
            interval: setInterval(() => {
                this.forceUpdate()
                this.checkAutoSubmit()
            }, 1000),
            autoSubmitted: false
        }
    }

    componentWillUnmount() {
        clearInterval(this.state.interval)
    }

    checkAutoSubmit() {
        if (this.state.autoSubmitted || this.props.finished || !this.props.onAutoSubmit) {
            return
        }

        const now = new Date()
        const deadline = new Date(this.props.deadline)
        const extraTimeMs = (this.props.extraTimeAllowance || 0) * 60 * 1000
        const effectiveDeadline = new Date(deadline.getTime() + extraTimeMs)

        if (now > effectiveDeadline) {
            this.setState({ autoSubmitted: true })
            this.props.onAutoSubmit()
        }
    }

    render() {
        const { started, deadline, extraTimeAllowance, finished } = this.props
        const now = new Date()
        const startTime = new Date(started)
        const baseDeadline = new Date(deadline)
        const extraTimeMs = (extraTimeAllowance || 0) * 60 * 1000
        const effectiveDeadline = new Date(baseDeadline.getTime() + extraTimeMs)

        let endTime = now
        if (finished) {
            endTime = new Date(finished)
        }

        const elapsedMs = endTime.getTime() - startTime.getTime()
        const elapsedMinutes = Math.floor(elapsedMs / (1000 * 60))
        const elapsedSeconds = Math.floor((elapsedMs % (1000 * 60)) / 1000)

        let remainingMs = effectiveDeadline.getTime() - now.getTime()
        let remainingMinutes = Math.floor(Math.max(0, remainingMs) / (1000 * 60))
        let remainingSeconds = Math.floor(Math.max(0, remainingMs % (1000 * 60)) / 1000)

        const isOvertime = remainingMs < 0
        const showWarning = remainingMs < 5 * 60 * 1000 && remainingMs > 0

        if (finished) {
            return (
                <span style={{ color: '#666' }}>
                    {elapsedMinutes.toString().padStart(2, "0")}:{elapsedSeconds.toString().padStart(2, "0")}
                </span>
            )
        }

        return (
            <span style={{
                color: isOvertime ? '#d32f2f' : showWarning ? '#f57c00' : '#2e7d32',
                fontWeight: showWarning || isOvertime ? 'bold' : 'normal'
            }}>
                {remainingMinutes.toString().padStart(2, "0")}:{remainingSeconds.toString().padStart(2, "0")}
                {extraTimeAllowance && extraTimeAllowance > 0 ? ` (+${extraTimeAllowance}m)` : ''}
                {isOvertime && ' - OVERTIME'}
            </span>
        )
    }
}